var resources = require('items-view-strings');
    var strings = resources['_/qeer2RX4npJ7blTMn1awg'];
export { strings };
export default strings;
